import createTabs from '@PROJECT_ROOT/assets/shared/js/tabs';
import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import { createDynamicCalendar } from '@PROJECT_ROOT/assets/desktop/js/search/Calendar';
import { triggerGoogleAnalyticsSendEvent } from '@PROJECT_ROOT/assets/desktop/js/library/triggerGoogleAnalyticsSend';

const slideToggleTime = 100;

/**
 * Funkcionalnost kartice jedinice na rezultatima pretrage.
 */
function openUnitCardUnconfigured(
    $,
    window,
    $post,
    createSimplePrivateGallery, // eslint-disable-line no-shadow
    createDynamicCalendar, // eslint-disable-line no-shadow
    triggerGoogleAnalyticsSendEvent, // eslint-disable-line no-shadow
    options,
    createTabs, // eslint-disable-line no-shadow
) {
    const { unitToggler, openTriggered, openPricelist } = options;
    const $accordion = $(unitToggler).siblings('.unitMoreInfo');
    const $galleryContainer = $accordion.find('.searchPrivateUnitGallery');
    const unitId = $(unitToggler).data('unit-id');

    $accordion.slideToggle(slideToggleTime);
    $(unitToggler).closest('li').toggleClass('opened');
    unitToggler.classList.toggle('opened');

    if (!alreadyLoaded($(unitToggler))) {
        initTabs($accordion, unitId, $, $post);
        gallerySetUp($galleryContainer, unitId);
        initShowAllPricelist($accordion);
    }

    setTimeout(() => scrollUnitToVisibleArea(unitToggler.classList.contains('opened')), 100);

    if (!openTriggered) {
        sendToggleCardGoogleAnalytics(unitToggler.classList.contains('opened'));
    }

    function alreadyLoaded(element) {
        if ($(element).data('loaded')) {
            return true;
        }

        $(element).data('loaded', true);

        return false;
    }

    function scrollUnitToVisibleArea(opened) {
        if (opened) {
            const accordionViewport = $accordion.offset().top - $(window).height();
            const winScrollTop = $(window).scrollTop();

            if (accordionViewport < winScrollTop) {
                if (winScrollTop - accordionViewport < 420) {
                    $('html, body').animate({ scrollTop: accordionViewport + 470 });
                }
            }
        }
    }

    function initTabs($container) {
        const pricelist = {
            headingSelector: $container.find('.searchPriceTab'),
            contentSelector: $container.find('.unitPriceListContent'),
        };

        const calendar = {
            headingSelector: $container.find('.searchAvailabilityTab'),
            contentSelector: $container.find('.unitCalendarContent'),
            onTabOpen() {
                if (!alreadyLoaded(calendar.headingSelector)) {
                    createDynamicCalendar({
                        url: $('#unitDetailsData').data('url-calendar'),
                        parameters: { unitId, from: $('#unitDetailsData').data('from') },
                        $calendarContent: $container.find(calendar.contentSelector),
                    })();

                    triggerGoogleAnalyticsSendEvent('Rezultati pretrage', 'Kalendar', '');
                }
            },
        };

        const pricelistUrl = $('#unitDetailsData').data('url-pricelist');
        const pricelistLoader = $post(pricelistUrl, { unitId });
        pricelistLoader.then((pricelistHtml) => {
            pricelist.contentSelector[0].innerHTML = pricelistHtml;

            if (openPricelist) {
                const $unitAdditionalInfo = $accordion.find('.qrAdditionalInfo');
                if (!$unitAdditionalInfo.hasClass('open')) {
                    togglePricelist($unitAdditionalInfo);
                }
            }
        });

        createTabs([pricelist, calendar]);
    }

    function gallerySetUp($container) {
        const imageElement = $container.find('.currentImage img')[0];
        const unitGalleryUrl = $('#galleryData').data('url-unit');
        const imageLoader = $post(unitGalleryUrl, { unitId });
        const $galleryHolder = $container.parents('.unitSearchGallery');
        let gallery;

        imageLoader.then((images) => {
            if (images) {
                imageElement.src = images[0].url;
                imageElement.alt = images[0].alt;
                imageElement.title = images[0].title;
                $galleryHolder.css('visibility', 'visible');
                gallery = initializeGallery(images, imageElement, $container);

                gallery.afterNewImageDisplay((data) => {
                    triggerGoogleAnalyticsSendEvent(
                        'Rezultati pretrage', 'Galerija 2', `listanje-${data.currentIndex}/${data.totalImages}`,
                    );
                });
            }
        });
    }

    function initializeGallery(images, imageElement, $container) {
        return createSimplePrivateGallery({
            imageElement,
            source: images,
            nextButton: $container.find('.simpleGalleryNext')[0],
            previousButton: $container.find('.simpleGalleryPrev')[0],
            counterElement: $container.find('.simpleGalleryCounter')[0],
            imageDescription: $container.find('figcaption')[0],
            toggleImageDescription: true,
            galleryHeight: $container.height(),
        });
    }

    function initShowAllPricelist($unitContainer) {
        $unitContainer.on('click', '.qrAdditionalInfo', function showPricelist() {
            togglePricelist($(this));
        });
    }

    function togglePricelist($showMore) {
        $showMore.toggleClass('open', slideToggleTime);
    }

    function sendToggleCardGoogleAnalytics(opened) {
        const category = 'Rezultati pretrage';
        const action = 'Izbornik jedinica';
        const label = opened ? 'otvori' : 'zatvori';

        triggerGoogleAnalyticsSendEvent(category, action, label);
    }
}

function closeOtherCardsInFacilityUnconfigured({ facility, unitId }, openUnitCard) {
    const openedCards = facility.querySelectorAll(`.unitInfo.opened:not([data-unit-id="${unitId}"])`);
    openedCards.forEach((openedCard) => openUnitCard({ unitToggler: openedCard, openTriggered: true })());
}

const openUnitCard = (options) => openUnitCardUnconfigured.bind(
    null,
    $,
    window,
    $.post,
    createSimplePrivateGallery,
    createDynamicCalendar,
    triggerGoogleAnalyticsSendEvent,
    options,
    createTabs,
);

const closeOtherCardsInFacility = (options) => closeOtherCardsInFacilityUnconfigured.bind(null, options, openUnitCard);

export {
    openUnitCardUnconfigured,
    openUnitCard,
    closeOtherCardsInFacilityUnconfigured,
    closeOtherCardsInFacility,
};
